<div class="col-md-12 category-selection-container">
  <button type="button" [ngClass]="category.key === selectedCategory ? 'btn-actvtytp' : 'btn'"
          *ngFor="let category of categorySubcategoryMap | keyvalue" (click)="selectCategory(category.key)">
    {{category.key}}
  </button>
</div>
<div class="col-md-12 sub-category-select">
  <select class="form-select" *ngIf="showSubcategorySelector && showSubCategoryDropdown()"
          (change)="selectSubCategory($event.target.value)">
    <option [disabled]="true" selected value="">Select Sub Category</option>
    <option *ngFor="let subcategory of categorySubcategoryMap?.get(selectedCategory)">
      {{subcategory}}
    </option>
  </select>
</div>